import type { ApiConfig } from '@/providers/ApiConfigProvider';
import type { CreateExportJobMutationResult, ExportInput } from '@/types/export';
import { graphqlQuery } from './graphql';

const CREATE_EXPORT_JOB_MUTATION = `
  mutation CreateExportJob($export: ExportInput!) {
    export {
      createExportJob(input: $export) {
        id
      }
    }
  }
`;

interface CreateExportJobResponse {
  export: {
    createExportJob: CreateExportJobMutationResult;
  };
}

export async function createExportJobMutation(
  apiConfig: Pick<ApiConfig, 'apiBaseUrl' | 'getHeaders'>,
  input: ExportInput,
): Promise<CreateExportJobMutationResult> {
  const response = await graphqlQuery<CreateExportJobResponse>(apiConfig, CREATE_EXPORT_JOB_MUTATION, {
    export: input,
  });

  return response.export.createExportJob;
}
